import { RPUser } from '@hazadapt-git/public-core-base'
import React, { FC } from 'react'
import { Dialog, LoadingButton } from '../atoms'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { useOrganization } from '../../lib/hooks/useOrganization'

interface TransferOrgOwnershipModalProps {
    user: RPUser
    open?: boolean
    onClose(): void
}

export const TransferOrgOwnershipModal: FC<TransferOrgOwnershipModalProps> = ({
    user,
    open,
    onClose,
}) => {
    const { handleTransferOwnership } = useOrganization()

    const onTransferOwnership = async (user: RPUser) => {
        await handleTransferOwnership(user)
        onClose()
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title="Transfer Ownership"
            content={
                <Typography>
                    Are you sure you want to transfer ownership to{' '}
                    {user.first_name} {user.last_name}? You cannot undo this
                    action.
                </Typography>
            }
            ctas={[
                <Button
                    key="cancel-transfer"
                    onClick={onClose}
                    variant="outlined"
                >
                    Cancel
                </Button>,
                <LoadingButton
                    key="confirm-transfer"
                    onClickAsync={async () => await onTransferOwnership(user)}
                >
                    Confirm Transfer
                </LoadingButton>,
            ]}
        />
    )
}
